export default __webpack_public_path__ + "static/media/r2.a9f86f38.jpg";